
const Feed = () => {
    return (
        <h2 className="text-5xl font-extrabold mb-4">
            Coming Soon
        </h2>
    )
}

export default Feed;